import * as tslib_1 from "tslib";
import { ChangeDetectorRef, ElementRef, ViewContainerRef } from '@angular/core';
import Hls from 'hls.js';
import { InputConverter, JSONConverter } from '../../../inputConverter';
import { DocumentSources } from '../../../types';
import { BaseComponent } from '../../base.component';
var GalleryComponent = /** @class */ (function (_super) {
    tslib_1.__extends(GalleryComponent, _super);
    function GalleryComponent(_vcr, changeDetectorRef) {
        var _this = _super.call(this, _vcr) || this;
        _this.changeDetectorRef = changeDetectorRef;
        _this.currentImageIndex = 0;
        return _this;
    }
    Object.defineProperty(GalleryComponent.prototype, "imageSources", {
        get: function () {
            return this._imageSources;
        },
        set: function (value) {
            this._imageSources = JSONConverter(value);
            this.mediaType = 'image';
            this.refreshPhotos();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GalleryComponent.prototype, "videoSource", {
        get: function () {
            return this._videoSource;
        },
        set: function (value) {
            var _this = this;
            this._videoSource = JSONConverter(value);
            this.mediaType = 'video';
            setTimeout(function () { _this.initializeHls(); }, 200);
            this.refreshPhotos();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GalleryComponent.prototype, "currentTitle", {
        get: function () {
            return this.imageSources && this.imageSources.length > 0 && this.currentImageIndex <= this.imageSources.length && this.imageSources[this.currentImageIndex]
                ? this.imageSources[this.currentImageIndex].title
                : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GalleryComponent.prototype, "currentUrl", {
        get: function () {
            if (this.mediaType === 'image') {
                if (this.imageSources && this.imageSources.length > 0 && this.currentImageIndex <= this.imageSources.length && this.imageSources[this.currentImageIndex]) {
                    var document_1 = this.imageSources[this.currentImageIndex];
                    return document_1.source === DocumentSources.VIDEO ? document_1.thumbnail : document_1.url;
                }
            }
            else {
                return this.videoSource.url || '';
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GalleryComponent.prototype, "currentDescription", {
        get: function () {
            return this.imageSources && this.imageSources.length > 0 && this.currentImageIndex <= this.imageSources.length && this.imageSources[this.currentImageIndex]
                ? this.imageSources[this.currentImageIndex].description
                : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GalleryComponent.prototype, "currentAltText", {
        get: function () {
            return this.imageSources && this.imageSources.length > 0 && this.currentImageIndex <= this.imageSources.length && this.imageSources[this.currentImageIndex]
                ? this.imageSources[this.currentImageIndex].description
                : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GalleryComponent.prototype, "currentPosition", {
        get: function () {
            return this.imageSources ? this.currentImageIndex + 1 + " of " + this.imageSources.length : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GalleryComponent.prototype, "isMultiImage", {
        get: function () {
            return this.imageSources && this.imageSources.length > 1;
        },
        enumerable: true,
        configurable: true
    });
    GalleryComponent.prototype.refreshPhotos = function () {
        this.changeDetectorRef.detectChanges();
    };
    GalleryComponent.prototype.previousImage = function () {
        if (this.currentImageIndex === 0) {
            this.currentImageIndex = this.imageSources.length - 1;
        }
        else {
            this.currentImageIndex -= 1;
        }
        this.refreshPhotos();
    };
    GalleryComponent.prototype.nextImage = function () {
        if (this.currentImageIndex === this.imageSources.length - 1) {
            this.currentImageIndex = 0;
        }
        else {
            this.currentImageIndex += 1;
        }
        this.refreshPhotos();
    };
    GalleryComponent.prototype.initializeHls = function () {
        var _this = this;
        if (this.videoSource && this.videoSource.url) {
            this.video = this.videoPlayer.nativeElement;
            var canPlayNatively = this.video.canPlayType('application/vnd.apple.mpegURL') !== '';
            if (!canPlayNatively) {
                if (this.hls) {
                    this.hls.destroy();
                }
                if (Hls.isSupported()) {
                    this.hls = new Hls();
                    this.hls.loadSource(this.videoSource.url.toString());
                    this.hls.attachMedia(this.video);
                    this.hls.on(Hls.Events.MANIFEST_PARSED, function () {
                        _this.video.muted = true; // Mute the video for autoplay to work
                        _this.video.play();
                    });
                }
            }
            else {
                this.video.src = this.videoSource.url;
                this.video.load();
            }
        }
        else if (this.video) {
            this.video.pause();
        }
    };
    tslib_1.__decorate([
        InputConverter(JSONConverter),
        tslib_1.__metadata("design:type", Object),
        tslib_1.__metadata("design:paramtypes", [Object])
    ], GalleryComponent.prototype, "imageSources", null);
    tslib_1.__decorate([
        InputConverter(JSONConverter),
        tslib_1.__metadata("design:type", Object),
        tslib_1.__metadata("design:paramtypes", [Object])
    ], GalleryComponent.prototype, "videoSource", null);
    return GalleryComponent;
}(BaseComponent));
export { GalleryComponent };
